import React, { useState } from 'react';
import useLoginDetailEmployee from '../../hooks/useLoginDetailEmployee';

const EmployeeLoginDetails = () => {
  const [page, setPage] = useState(1);
  const perPage = 20;
  const { data, isLoading, isError, error } = useLoginDetailEmployee(page, perPage);

  const logins = data?.data || [];
  const meta = data?.meta || {};
  const totalPages = meta.last_page || 1;

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setPage(newPage);
    }
  };

  if (isLoading) {
    return (
      <div className="text-center">
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <p className="mt-2">Loading login details...</p>
      </div>
    );
  }

  if (isError) {
    return (
      <div className="text-center">
        <p className="text-danger">{error?.message || 'Failed to load data'}</p>
      </div>
    );
  }

  return (
    <div>
              <div className="title-header option-title d-flex align-items-center justify-content-between mb-3">
                <h2 className="mb-0">Employee Login Details</h2>
              </div>
              {logins.length === 0 ? (
                <div className="text-center py-4">
                  <p className="text-muted">No login records found.</p>
                </div>
              ) : (
                <>
                  <div className="table-responsive table-product">
                    <table className="table all-package theme-table align-middle" id="employee_login_table">
                      <thead className="table-light">
                        <tr>
                          <th className="text-center">ID</th>
                          <th className="text-start">Name</th>
                          <th className="text-start">Login Time</th>
                          <th className="text-center">IP Address</th>
                          <th className="text-start">User Agent</th>
                        </tr>
                      </thead>
                      <tbody>
                        {logins.map((row, idx) => (
                          <tr key={idx}>
                            <td className="text-center">{row.employee_id}</td>
                            <td className="text-start">{row.name}</td>
                            <td className="text-start">{row.login_time}</td>
                            <td className="text-center">{row.ip_address}</td>
                            <td className="text-start text-truncate" style={{ maxWidth: 200 }}>{row.user_agent}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  {/* Pagination Controls */}
                  <nav className="d-flex justify-content-center mt-4">
                    <ul className="pagination">
                      <li className={`page-item${page === 1 ? ' disabled' : ''}`}>
                        <button className="page-link" onClick={() => handlePageChange(page - 1)} disabled={page === 1}>&laquo; Prev</button>
                      </li>
                      {Array.from({ length: totalPages }, (_, i) => i + 1).map((pg) => (
                        <li key={pg} className={`page-item${pg === page ? ' active' : ''}`}>
                          <button className="page-link" onClick={() => handlePageChange(pg)}>{pg}</button>
                        </li>
                      ))}
                      <li className={`page-item${page === totalPages ? ' disabled' : ''}`}>
                        <button className="page-link" onClick={() => handlePageChange(page + 1)} disabled={page === totalPages}>Next &raquo;</button>
                      </li>
                    </ul>
                  </nav>
                </>
              )}
    </div>
  );
};

export default EmployeeLoginDetails; 